module.exports = __webpack_public_path__ + "static/media/sidebar-4.897b4cf9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sidebar-4.jpg
// module id = 790
// module chunks = 0